<!--
2023-08-17 YTW Vip体系
-->
<template>
  <div class="main-content">
    <div class="top">
      <div style="width: 20vw"><TopBack id="TopBack"/></div>
      <div class="title" style="width: 60vw;">{{ $t('lang.VIP.recordOfCollection') }}</div>
      <div style="width: 20vw;height: 1px"></div>
    </div>
    <div class="background-content">
      <div class="toolBox">
        <div class="greenFrame">
          <div id="typeSelect" class="current-select" @click="showSelectList(1)">
            <span>{{typeShow.name.substring(0,13)}}</span>
            <div><img :src="triangle"></div>
          </div>
          <div id="dateSelect" class="current-select" @click="showSelectList(2)">
            <span>{{dateShow.name}}</span>
            <div><img :src="triangle"></div>
          </div>
        </div>
      </div>
      <div class="masks" @click="noShowSelect" v-show="showTypeSelect">
        <div id="typeList" class="type-container"
             :style="{background:'#1B1B1B'}">
          <div id="typeBk" class="selectList">
            <div class="option pointer select-row"
                 :class="{'selectactive':typeShow.key == item.key}"
                 v-for="(item, index) in typeList"
                 :key="index" @click="selectType(item,index)">
              <div>{{item.name}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="masks" @click="noShowSelect" v-show="showDateSelect">
        <div id="dateList" class="date-container"
             :style="{background:'#1B1B1B'}">
          <div id="dateBk" class="selectList">
            <div class="option pointer select-row"
                 :class="{'selectactive':dateShow.key === item.key}"
                 v-for="(item, index) in dateList"
                 :key="index" @click="selectDateSpan(item,index)">
              <div>{{item.name}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row-list" ref="row-list">
        <Loadmore        :bottomPullText="''"
                         :bottomDropText="''"
                         :bottomLoadingText="''"
                         :auto-fill="false"
                         :bottom-method="fetchRecord"
                         :bottom-all-loaded="allLoaded"
                         ref="loadmore">
          <div class="gift-row" v-for="(item, index) in giftList" :key="index">
            <div class="content-box">
              <div class="box-left">
                <div class="dueDate">
                  {{ item.CreatedDate }}
                </div>
                <div class="type-title">{{ getValByKey(item.Type) }}</div>
              </div>
              <div class="box-right">
                <div class="type-content">
                  <div class="gift-text">
                    <div></div>
                    <div class="text-right">+ {{ $t('lang.account.currencyType') }}{{ item.Amount }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="showMore" v-if="!allLoaded"><img :src="showMore" alt=""></div>
        </Loadmore>
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/service'
import TopBack from '@/components/TopBack/index'
import triangle from '@/assets/images/vip/triangle.svg'
import showMore from '@/assets/images/common/showMore.gif'
import {Loadmore} from 'mint-ui'

export default {
  name: 'VipMembershipRecord',
  computed: {
  },
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      triangle,
      showMore,
      showTypeSelect: false,
      showDateSelect: false,
      typeList: this.$t('lang.VIP.typeList'),
      dateList: this.$t('lang.VIP.dateList'),
      giftList: [],
      allLoaded: true,
      firstLoad: true,
      typeShow: this.$t('lang.VIP.typeList')[0],
      dateShow: this.$t('lang.VIP.dateList')[0],
      currentTypeIndex: 0,
      currentDateIndex: 0,
      pageNumber: -1
    }
  },
  components: {
    Loadmore,
    TopBack,
    triangle
  },
  watch: {
    '$store.state.locale': function () {
      this.typeList = this.$t('lang.VIP.typeList')
      this.dateList = this.$t('lang.VIP.dateList')
      this.typeShow = this.$t('lang.VIP.typeList')[this.currentTypeIndex]
      this.dateShow = this.$t('lang.VIP.dateList')[this.currentDateIndex]
    }
  },
  mounted () {
    this.fetchRecord()
  },
  updated () {
  },
  methods: {
    fetchRecord () {
      if (!this.userInfo || !this.userInfo.UserId) {
        this.$router.push('/Login')
        return
      }
      let that = this
      this.pageNumber++
      const data = {
        RewardType: this.typeShow.key,
        Days: this.dateShow.key,
        UserId: this.userInfo.UserId,
        PageNumber: this.pageNumber
      }
      request('post', 'innovation/vip/get_vip_reward', data, false).then(result => {
        if (result && result !== -1) {
          that.giftList = that.giftList.concat(result)
          if (result.length < 10) {
            that.allLoaded = true
          } else {
            that.allLoaded = false
          }
          if (!this.firstLoad) {
            this.$refs.loadmore.onBottomLoaded()
          }
          this.firstLoad = false
          // 滚到底
          let element = this.$refs['row-list']
          setTimeout(() => {
            element.scrollTo(0, element.scrollHeight)
          }, 0)
        }
      })
    },
    getValByKey (key) {
      let name = ''
      this.typeList.some((item) => {
        if (item.key === key) {
          name = item.name
          return item
        }
      })
      return name
    },
    showSelectList (type) {
      if (type === 1) {
        let selectElement = document.getElementById('typeSelect')
        let listElement = document.getElementById('typeList')
        listElement.style.top = selectElement.offsetHeight + selectElement.offsetTop + 'px'
        listElement.style.left = selectElement.offsetLeft + 'px'
        listElement.style.width = selectElement.offsetWidth + 'px'
        this.showTypeSelect = true
      } else {
        let selectElement = document.getElementById('dateSelect')
        let listElement = document.getElementById('dateList')
        listElement.style.top = selectElement.offsetHeight + selectElement.offsetTop + 'px'
        listElement.style.left = selectElement.offsetLeft + 'px'
        listElement.style.width = selectElement.offsetWidth + 'px'
        this.showDateSelect = true
      }
    },
    selectType (item, index) {
      this.giftList = []
      this.typeShow = item
      this.currentTypeIndex = index
      this.pageNumber = -1
      this.allLoaded = true
      this.firstLoad = true
      this.fetchRecord()
    },
    selectDateSpan (item, index) {
      this.giftList = []
      this.dateShow = item
      this.currentDateIndex = index
      this.pageNumber = -1
      this.allLoaded = true
      this.firstLoad = true
      this.fetchRecord()
    },
    noShowSelect () {
      this.showTypeSelect = false
      this.showDateSelect = false
    },
    close () {
      this.showGame = false
    }
  }
}
</script>

<style lang="less" scoped>
.main-content {
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 56px 0 70px 0; // 2022-03-27 CHP Fix tab被topbar遮挡
  overflow-x: hidden;
  .top{
    display: flex;
    height: 42px;
    .title{
      text-align: center;
      margin-top: 8px;
      font-size: 22px;
      line-height: 34px;
      color: #FFFFFF;
      font-weight: 700;
    }
  }
  .background-content{
    width: 100%;
    height: calc(98vh - 168px);
    margin-top: 2vh;
    background: #FFFFFF;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    .toolBox{
      display: flex;
      width: 100vw;
      margin: 1vh auto 0 auto;
      text-align: left;
      .greenFrame{
        justify-content: space-between;
        display: flex;
        height: 40px;
        width: 90%;
        border-radius:4px;
        margin: 10px auto;
        .current-select{
          position: relative;
          justify-content: space-between;
          display: flex;
          max-width: 45vw;
          min-width: 115px;
          white-space: nowrap;
          font-weight: 700;
          text-align: left;
          color: #FFFFFF;
          background-color: #1E1E1E;
          border-radius: 6px;
          height: 38px;
          line-height: 35px;
          span{
            font-size: 18px;
            color: #FFFFFF;
            margin: 2px 0 2px 10px;
          }
          div {
            text-align: center;
            width: 40px;
            img{
              width: 17px;
              float: right;
              margin: 15px 8px;
            }
          }
        }
      }
      img{
        width: 65px;
        margin-top: -10px;
        margin-left: -30px;
        z-index: 5000;
      }
    }
    .masks {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.1);
      z-index: 101;
      .type-container {
        position: absolute;
        top: 0;
        left: 0;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        height: max-content;
        min-width: max-content;
        .selectList {
          height: max-content;
          text-align: left;
          z-index: 5;
          .option {
            white-space: nowrap;
            padding: 1px 10px;
            margin: 5px 0;
            display: flex;
            width: max-content;
            font-size: 18px;
            font-weight: 700;
            line-height: 26px;
            div {
              width: 100%;
              height: 30px;
            }
          }
          .selectactive {
            color: #fff;
          }
        }
      }
      .date-container {
        position: absolute;
        top: 0;
        left: 0;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        height: max-content;
        min-width: max-content;
        .selectList {
          height: max-content;
          padding: 2px 0;
          text-align: left;
          z-index: 5;
          .option {
            white-space: nowrap;
            padding: 1px 10px;
            margin: 5px 0;
            display: flex;
            width: max-content;
            font-size: 18px;
            font-weight: 700;
            line-height: 26px;
            div {
              width: 100%;
              height: 30px;
            }
          }
          .selectactive {
            color: #fff;
          }
        }
      }
    }
    .row-list {
      position: relative;
      top: 1vh;
      left: 50%;
      transform: translate(-50%);
      width: 90%;
      height: calc(96vh - 228px);
      overflow-x: hidden;
      overflow-y: auto;
      .gift-row {
        display: flex;
        margin: 1.6vh 0;
        padding: 6px 15px;
        height: 9.5vh;
        border: 1px solid;
        background:  #252525;
        border-radius: 6px;
        .content-box {
          width: 100%;
          display: flex;
          justify-content: space-between;
          .box-left {
            position: relative;
            height: 100%;
            .dueDate {
              position: absolute;
              top: 5px;
              width: 40vw;
              text-align: left;
              color: #A1A1A1;
              font-size: 4.5vw;
              font-weight: 700;
              line-height: 4.5vw;
            }
            .type-title {
              position: absolute;
              bottom: 2px;
              width: max-content;
              color: #FFFFFF;
              font-size: 6.13vw;
              font-weight: 700;
              line-height: 6.13vw;
              text-align: left;

            }
          }
          .box-right {
            height: 100%;

            .type-content {
              height: 100%;
              display: flex;
              align-items: center;

              .gift-text {
                position: relative;
                display: flex;
                white-space: nowrap;
                height: 100%;

                .text-right {
                  position: absolute;
                  bottom: 1px;
                  right: 0;
                  width: max-content;
                  text-align: right;
                  font-size: 7.5vw;
                  font-weight: 700;
                  line-height: 7.5vw;
                  color: #F4E3BF;
                }
              }

              img {
                width: 40px;
                height: 52px;
                object-fit: contain;
                margin-top: -6px;
              }
            }
          }
        }
      }

      .gift-row:first-of-type {
        margin: 0px 0px;
      }
    }
    .row-list::-webkit-scrollbar {
      display: none;
    }
    .showMore {
      text-align: center;
      img {
        width: 10px;
      }
    }
  }
}

.main-content::-webkit-scrollbar {
  display: none
}

</style>



// WEBPACK FOOTER //
// src/pages/VipMembershipRecord/index.vue